import React, { useEffect } from "react";
import { Card, Spin } from "antd";
import "antd/lib/button/style";
import { Table, Tag, Space } from "antd";
import { Button } from "antd";
import { DownloadKind, downloadStaticFile } from "../unit/download";
import { DownloadOutlined } from "@ant-design/icons";

const Download = () => {
  const columns = [
    {
      title: "文件名",
      dataIndex: "fileName",
      key: "fileName",
      render: (text: string | number | boolean) => {
        if (typeof text === "string") {
          return <span>《{text}》</span>;
        }
      },
    },

    {
      title: "",
      dataIndex: "keyName",
      key: "keyName",
      width: 100,
      render: (text: string | number | boolean) => {
        if (typeof text === "string") {
          return (
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              className="download_text"
              onClick={() => {
                downloadStaticFile(text as DownloadKind);
              }}
            >
              下载
            </Button>
          );
        }
      },
    },
  ];
  return (
    <Card title="" bordered={false} style={{ width: "100%" }}>
      <Table
        showHeader={false}
        bordered={true}
        columns={columns}
        dataSource={[
          {
            fileName: "保证金协议",
            keyName: "DepositAgreement",
          },
          {
            fileName: "履约保函",
            keyName: "GuaranteeImplement",
          },
          {
            fileName: "银行保函说明",
            keyName: "CorpGuaranteeApply",
          },
          {
            fileName: "保证金缴款通知",
            keyName: "DepositPaymentNotice",
          },
          {
            fileName: "保证金退款申请",
            keyName: "DepositRefoundApply",
          },
          {
            fileName: "用户手册",
            keyName: "Manual",
          },
        ]}
        pagination={false}
      />
    </Card>
  );
};
export default Download;
